import React, {
  useCallback,
  useMemo,
  useState,
  useRef,
  useEffect,
} from "react";
import moment from "moment-jalaali";
import { Line } from "react-chartjs-2";
import { ChartTypes } from "./ChartTypes";
import { useLocation, useParams } from "react-router";
import { useSelector } from "react-redux";
import Select from "./Select/Select";
import SpinnerHandler from "../../hoc/SpinnerHandler/SpinnerHandler";
// import useHttp from '../../hooks/http';
import useAsync from "../../hooks/asyncRequests";
import Header from "../../Components/UI/Header/Header";
import Footer from "../../Components/UI/Footer/Footer";
import Icon from "@mdi/react";
import { mdiCloudUploadOutline, mdiPageFirst, mdiPageLast } from "@mdi/js";
import CInput from "../../Components/UI/CInput/CInput";
// import { Compare, Close } from "@mui/icons-material";
// import Modal from "../../Components/Modal";
import { Helmet } from "react-helmet";

const lbDic = {
  discharge: "دبی",
  volume: "حجم",
  level: "تراز",
  area: "سطح",
  total_input: "مجموع ورودی",
  rainfall: "بارش",
  evp: "تبخیر",
  medium_temp: "دمای هوا",
  maximum_temp: "دمای بیشینه",
  minimum_temp: "دمای کمینه",
  relative_humidity: "رطوبت نسبی",
  wind_direction_degree: "جهت باد",
  wind_speed_knots: "سرعت باد",
};

const ChartPages = () => {
  const [chartData, setChartData] = useState({});
  const [value, setValue] = useState();
  const [Range, setRange] = useState(1);

  const { type } = useParams();
  const location = useLocation();
  const thisPageData = useMemo(() => ({ ...ChartTypes[type] }), [type]);
  const token = useSelector((state) => state.auth.Token);

  useEffect(() => {
    if (type === "Synoptic" || type === "Lake") {
      setValue(thisPageData.options[thisPageData.options.length - 1].gainValue);
    }
  }, [type, thisPageData]);

  const { isLoadingAsync, finalData, clearAsync, NewRequest, Key } = useAsync({
    Key: 1,
    reqData: {
      chart: {
        url: `chart/${thisPageData.url}/?range=1${
          thisPageData.id ? "&" + thisPageData.id + "=" + location.state.id : ""
        }`,
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
    },
  });

  const [AllChartData, setAllChartData] = useState({});
  const [Color, setColor] = useState("#9fa8da");
  const [Last, setLast] = useState();

  const [Start, setStart] = useState(moment());
  const [End, setEnd] = useState(moment());
  const [isLoading, setIsLoading] = useState();
  // const [open, setOpen] = useState(false);

  // const handleOpenModal = () => {
  //   setOpen(true);
  // };

  const chartRef = useRef(null);

  useEffect(() => {
    const colors = {};
    if (!thisPageData.singleOption) {
      thisPageData.options.forEach((element) => {
        colors[element.gainValue] = element.color;
      });
      setColor(colors);
    } else {
      colors[thisPageData.singleOption[0].gainValue] =
        thisPageData.singleOption[0].color;
      setColor(colors);
      setValue(
        thisPageData.singleOption[thisPageData.singleOption.length - 1]
          .gainValue
      );
    }
    // console.log(colors);
  }, [thisPageData, setColor]);

  useEffect(() => {
    console.log("data is: ", finalData);
    if (!finalData || !Key || Key === "loading") {
      return;
    }

    if (AllChartData[Key]) {
      return;
    }

    const { chart } = finalData;

    if (chart && !chart.error && chart?.data?.length > 0) {
      const allChartData = { labels: [] };
      let allOptions;

      if (thisPageData.singleOption) {
        allOptions = thisPageData.singleOption;
      } else {
        allOptions = thisPageData.options;
      }

      allOptions.map((e) => {
        allChartData[e.gainValue] = [];
        return 0;
      });

      let date;
      chart.data.forEach((CD) => {
        date = moment(CD.date).format("jYYYY-jMM-jDD");
        allChartData.labels.push(date);
        allOptions.forEach((e) => {
          allChartData[e.gainValue].push({ y: CD[e.gainValue], x: date });
        });
      });

      const reversed = {};

      for (const key in allChartData) {
        reversed[key] = allChartData[key].reverse();
      }

      setAllChartData((pre) => {
        const p = { ...pre };
        p[Key] = reversed;
        return p;
      });

      setLast(chart.latest);

      setChartData({
        data: {
          datasets: [
            {
              pointHoverRadius: 5,
              pointHitRadius: 30,
              tension: 0.4,
              fill: false,
              cubicInterpolationMode: "monotone",
              parsing: false,
            },
          ],
        },
        options: {
          animation: false,
          normalized: true,
          spanGaps: true,
          // showLine: false,
          datasets: {
            line: {
              pointRadius: 0, // disable for all `'line'` datasets
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            yAxes: {
              title: {
                display: true,
                // text: 'yAxisTitle',
                font: {
                  size: 15,
                },
              },
            },
            xAxes: {
              x: {
                type: "time",
                time: {
                  unit: "month",
                },
              },
              title: {
                display: true,
                text: "Time Line",
                font: {
                  size: 15,
                },
              },
              ticks: {
                maxTicksLimit: 12,
              },
            },
          },
        },
      });
    }

    clearAsync();
  }, [
    finalData,
    AllChartData,
    setAllChartData,
    setChartData,
    clearAsync,
    thisPageData,
    Key,
    setLast,
  ]);

  // useEffect(() => console.log(AllChartData), [AllChartData]);
  // useEffect(() => console.log(Key), [Key]);

  useEffect(() => {
    if (!thisPageData.options && finalData) {
      setValue(thisPageData.singleOption[0].gainValue);
    }
  }, [thisPageData, setValue, finalData]);

  // const download = useCallback(() => {
  //   fetch(chartRef.current.toBase64Image(), {
  //     method: 'GET',
  //     headers: {},
  //   })
  //     .then((response) => {
  //       response.arrayBuffer().then(function (buffer) {
  //         const url = window.URL.createObjectURL(new Blob([buffer]));
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', `${value}.png`);
  //         document.body.appendChild(link);
  //         link.click();
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, [chartRef, value]);

  const chart = useMemo(() => {

    if (chartData) {
      let dt = null;
      if (chartData.data && chartData.data.datasets[0].data) {
        dt = chartData;
      }

      return dt && <Line ref={chartRef} {...dt} />;
    }
  }, [chartData]);

  useEffect(() => {
    if (value && AllChartData[Range]) {
      setChartData(
        (pre) =>
          pre &&
          Object.keys(pre).length && {
            ...pre,
            data: {
              labels: AllChartData[Range].labels,
              datasets: [
                {
                  ...pre.data.datasets[0],
                  label: location.state.name + " -- " + value,
                  data: AllChartData[Range][value],
                  // backgroundColor: `rgba(${Color[value]}, 0.4)`,
                  backgroundColor: `rgb(${Color[value]})`,
                  borderColor: `rgb(${Color[value]})`,
                },
              ],
            },
            options: {
              ...pre.options,
              scales: {
                ...pre.options.scales,
                yAxes: {
                  title: {
                    ...pre.options.scales.yAxes.title,
                    text: lbDic[value] ? lbDic[value] : value,
                    font: {
                      family: "IRANSansWeb",
                      size: 18,
                      weight: "bold",
                    },
                  },
                },
                xAxes: {
                  title: {
                    display: true,
                    text: "تاریخ",
                    font: {
                      size: 15,
                      family: "IRANSansWeb",
                      weight: "bold",
                    },
                  },
                },
              },
            },
          }
      );
    }
  }, [value, location, setChartData, AllChartData, Color, Range]);

  useEffect(() => {
    if (!AllChartData[Range] && Range !== 1) {
      NewRequest({
        NewKey: Range,
        NewReqData: {
          chart: {
            url: `chart/${thisPageData.url}/?range=${Range}${
              thisPageData.id
                ? "&" + thisPageData.id + "=" + location.state.id
                : ""
            }`,
            method: "GET",
            header: { Authorization: `Bearer ${token}` },
          },
        },
      });
    }
  }, [NewRequest, Range, AllChartData, location, thisPageData, token]);

  const navigation = useMemo(() => {
    return (
      <div className="center">
        <span onClick={() => setRange((pre) => pre + 1)}>
          <Icon
            path={mdiPageLast}
            title="NEXT"
            size={1}
            style={{ visibility: !Range ? "hidden" : "visible" }}
          />
        </span>
        <span>{Range}</span>
        <span onClick={() => setRange((pre) => (pre === 1 ? 1 : pre - 1))}>
          <Icon
            path={mdiPageFirst}
            title="PREVIOUS"
            size={1}
            style={{ visibility: Range === 1 ? "hidden" : "visible" }}
          />
        </span>
      </div>
    );
  }, [Range, setRange]);

  const downloadCSV = useCallback(() => {
    if (Start.format("YYYY-MM-DD") === End.format("YYYY-MM-DD")) {
      return;
    }

    setIsLoading(true);
    fetch(
      `http://213.233.177.17:8022/download/${thisPageData.download}?${
        thisPageData.downloadId
      }=${location.state.id}&start_date=${Start.format(
        "YYYY-MM-DD"
      )}&end_date=${End.format("YYYY-MM-DD")}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        response.headers.forEach((value, name) => {
          console.log(name + ": " + value);
        });
        return response.blob().then((data) => {
          const the = response.headers.get("Content-disposition");
          const thea = the.slice(the.indexOf('"') + 1, the.length - 1);
          console.log(the);
          console.log(thea);
          return {
            blob: data,
            fileName: thea,
          };
        });
      })
      .then(({ blob, fileName }) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = (fileName ? fileName : "matter") + ".csv";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again)
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }, [token, thisPageData, location, Start, End]);

  // const downloadChart = useMemo(() => {
  //   return (
  //     <div className='chartDownload' style={{ justifyContent: 'center', marginBottom: '0' }}>
  //       <button onClick={download}>
  //         دریافت نمودار <Icon path={mdiCloudUploadOutline} size={1} />
  //       </button>
  //     </div>
  //   );
  // }, [download]);

  const downloadUI = useMemo(() => {
    if (location.state.id && thisPageData.download) {
      return (
        <div className="chartDownload">
          <CInput
            config={{
              type: "calendar",
              placeholder: "تاریخ شروع",
            }}
            value={Start}
            direction="rtl"
            changed={setStart}
          />
          <CInput
            config={{
              type: "calendar",
              placeholder: "تاریخ پایان",
            }}
            value={End}
            direction="rtl"
            changed={setEnd}
          />
          <button onClick={() => downloadCSV()}>
            دریافت داده ها به فرمت CSV{" "}
            <Icon path={mdiCloudUploadOutline} size={1} />
          </button>
          {/* <button onClick={handleOpenModal}>
            مقایسه با برنامه
            <Compare />
          </button> */}
        </div>
      );
    } else return null;
  }, [downloadCSV, Start, End, setStart, setEnd, thisPageData, location]);

  // const ChartView = () => {
  //   const data = {
  //     data: {
  //       labels: ["مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
  //       datasets: [
  //         {
  //           type: "bar",
  //           label: "Bar Dataset",
  //           data: [10, 20, 30, 40, 10, 50],
  //           borderColor: "rgb(255, 99, 132)",
  //           backgroundColor: "rgba(255, 99, 132, 1)",
  //           hoverBackgroundColor: "rgba(255, 99, 132, 0.8)",
  //           barThickness: 15,
  //           borderRadius: 10,
  //         },
  //         {
  //           type: "bar",
  //           label: "Line Dataset",
  //           data: [25, 65, 10, 30, 40, 20],
  //           fill: false,
  //           borderColor: "rgb(54, 162, 235)",
  //           backgroundColor: "rgba(72,12,168,1)",
  //           hoverBackgroundColor: "rgba(2,12,168, 0.8)",
  //           barThickness: 15,
  //           borderRadius: 10,
  //         },
  //       ],
  //     },
  //     options: {
  //       maintainAspectRatio: false,
  //       responsive: true,
  //       animation: true,
  //       normalized: true,
  //       spanGaps: true,
  //       // showLine: false,
  //       datasets: {
  //         line: {
  //           pointRadius: 0, // disable for all `'line'` datasets
  //         },
  //       },
  //       plugins: {
  //         title: {
  //           display: true,
  //           text: "مقایسه برنامه",
  //           font: {
  //             family: "IRANSansWeb",
  //             size: 18,
  //             lineHeight: 5,
  //           },
  //         },
  //         legend: {
  //           labels: {
  //             // This more specific font property overrides the global property
  //             font: {
  //               size: 14,
  //               family: "IRANSansWeb",
  //             },
  //           },
  //           display: false,
  //         },
  //       },
  //       scales: {
  //         yAxes: {
  //           title: {
  //             display: true,
  //             // text: 'yAxisTitle',
  //             font: {
  //               size: 15,
  //               family: "IRANSansWeb",
  //             },
  //           },
  //         },
  //         xAxes: {
  //           x: {
  //             type: "time",
  //             time: {
  //               unit: "Month",
  //             },
  //           },
  //           title: {
  //             display: false,
  //             text: "سال",
  //             font: {
  //               size: 15,
  //               family: "IRANSansWeb",
  //             },
  //           },
  //           ticks: {
  //             // maxTicksLimit: 12,
  //           },
  //         },
  //       },
  //     },
  //   };
  //   return (
  //     <Modal open={open}>
  //       <div
  //         style={{
  //           display: "flex",
  //           flexDirection: "row-reverse",
  //           height: 25,
  //           alignItems: "center",
  //         }}
  //       >
  //         <Close style={{ cursor: "pointer" }} onClick={() => setOpen(false)} />
  //       </div>
  //       <div style={{ display: "flex", height: 350 }}>
  //         <Bar {...data} {...data} />
  //       </div>
  //     </Modal>
  //   );
  // };
  const detectTitle = () => {
    switch (type) {
      case "Hydrometric":
        return "هیدرومتریک";
      case "Synoptic":
        return "سینوپتیک";
      case "Lake":
        return "دریاچه";
      default:
        return;
    }
  };

  return (
    <SpinnerHandler isLoading={isLoadingAsync || isLoading}>
      <Helmet>
        <title>نمودار {detectTitle()}</title>
      </Helmet>
      <Header />
      {/* <ChartView /> */}
      <div className="chartInfo">
        <h2>{location.state.name}</h2>

        {thisPageData.options && (
          <Select
            value={value}
            setValue={setValue}
            list={thisPageData.options}
            Color={Color[value]}
            last={Last}
          ></Select>
        )}
        {thisPageData.singleOption && (
          <Select
            value={value}
            setValue={setValue}
            list={thisPageData.singleOption}
            Color={Color[value]}
            last={Last}
          ></Select>
        )}
      </div>

      <div className="center damChart">
        {navigation}
        <div>{chart}</div>
      </div>

      {/* {downloadChart} */}
      {downloadUI}
      <Footer />
    </SpinnerHandler>
  );
};

export default ChartPages;
